(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchItemDialogController', PatchItemDialogController);

    PatchItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchItem'];

    function PatchItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchItem) {
        var vm = this;
        vm.patchItem = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchItem.id !== null) {
                PatchItem.update(vm.patchItem, onSaveSuccess, onSaveError);
            } else {
                PatchItem.save(vm.patchItem, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
